"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _unistUtilVisit = _interopRequireDefault(require("unist-util-visit"));

var _Matcher2 = _interopRequireDefault(require("./lib/Matcher"));

/* eslint-disable no-param-reassign */
var transformer = function transformTree(tree) {
  var transform = function transformNode(node, parent) {
    var children = node.children;

    if (children) {
      for (var i = 0; i < children.length; i += 1) {
        transform(children[i], node);
      }

      return;
    }

    var value = node.value;

    var _Matcher = new _Matcher2["default"](value),
        shortcodes = _Matcher.shortcodes;

    if (shortcodes.length) {
      var _children = [];

      for (var _i = 0; _i < shortcodes.length; _i += 1) {
        var _shortcodes$_i = shortcodes[_i],
            type = _shortcodes$_i.type,
            identifier = _shortcodes$_i.identifier,
            attributes = _shortcodes$_i.attributes,
            start = _shortcodes$_i.start,
            end = _shortcodes$_i.end;

        _children.push({
          type: 'text',
          value: value.substring(0, start)
        });

        _children.push({
          type: type,
          identifier: identifier,
          attributes: attributes
        });

        _children.push({
          type: 'text',
          value: value.substring(end + 1)
        });

        parent.children = _children;
      }
    }
  };

  (0, _unistUtilVisit["default"])(tree, 'root', function (node) {
    transform(node);
  });
};

var remarkSubSup = function remarkSubSupPlugin() {
  return transformer;
};

var _default = remarkSubSup;
exports["default"] = _default;